import React, {
  FC, useEffect, useRef,
} from 'react';

import { Card } from 'components';

import styles from './styles.module.scss';
import { Collection } from '../interface';
import { ROUTES } from '../../../constants';

interface Image {
  idx: number;
  rank: number;
  type: string;
  attributes: string[];
}

interface Props {
  images: Image[];
  total: number;
  getImages: (isStackImage?: boolean) => void;
  collection: Collection;
}

export const List: FC<Props> = ({
  images,
  total,
  getImages,
  collection,
}) => {
  const cardsRef = useRef<{ [index: number]: HTMLAnchorElement | null }>({});
  const observer = useRef<IntersectionObserver | null>(null);
  const prevImages = useRef<Image[]>([]);

  if (images !== prevImages.current) {
    prevImages.current = images;
    cardsRef.current = {};
  }

  const addObserver = () => {
    observer.current?.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && images.length < total) {
          getImages(true);
        }
      });
    });
    const cardsIndexes = Object.keys(cardsRef.current);
    const lastIndex = cardsIndexes[cardsIndexes.length - 1];
    if (cardsRef.current[lastIndex]) observer.current.observe(cardsRef.current[lastIndex]);
  };

  useEffect(() => {
    addObserver();
  }, [images]);

  const getLink = typeof collection.number === 'number' ?
    (idx) => ROUTES.carsItemLink(collection.name, idx, collection.number) :
    (idx) => ROUTES.punksItemLink(collection.name, idx);

  return (
    <div className={styles.list}>
      <div className={styles.container}>
        {
          images.map((img, index) => (
            <Card
              to={getLink(img.idx)}
              key={img.idx}
              idx={img.idx}
              ref={(ref) => {
                cardsRef.current[index] = ref;
              }}
              collection={collection}
              tags={img.attributes}
              rank={img.rank}
              type={img.type}
            />
          ))
        }
      </div>
    </div>
  );
};
